import { initializeApp } from 'firebase/app'

let appGallery

export const getFirebaseAppGallery = () => {
  if (!appGallery) {
    appGallery = initializeApp({
      projectId: 'carto-app-gallery-1'
    })
  }
  return appGallery
}
